import { render, staticRenderFns } from "./dresden-files-accelerated.vue?vue&type=template&id=24dfee53&scoped=true&"
import script from "./dresden-files-accelerated.vue?vue&type=script&lang=js&"
export * from "./dresden-files-accelerated.vue?vue&type=script&lang=js&"
import style0 from "./dresden-files-accelerated.vue?vue&type=style&index=0&id=24dfee53&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24dfee53",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/fcs/fcs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24dfee53')) {
      api.createRecord('24dfee53', component.options)
    } else {
      api.reload('24dfee53', component.options)
    }
    module.hot.accept("./dresden-files-accelerated.vue?vue&type=template&id=24dfee53&scoped=true&", function () {
      api.rerender('24dfee53', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/sheets/dresden-files-accelerated.vue"
export default component.exports